module.exports = __webpack_public_path__ + "assets/img/landing-top-logo_bg.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing-top-logo_bg.png
// module id = 1946
// module chunks = 0